// extracted by mini-css-extract-plugin
export default {"case":"case_case__jYPSb","case__preview":"case_case__preview__azNdo","case__name":"case_case__name__2gyrZ","case__types":"case_case__types__zDmdi","type":"case_type__U5BRR"};